import api from './api';

export interface SitioMuestreo {
  id: number;
  id_planta: number;
  denominacion: string;
  georreferencia_lat: number;
  georreferencia_long: number;
  utilizado: number;
}

// Obtener todos los sitios de muestreo
export const getSitiosMuestreo = async (): Promise<SitioMuestreo[]> => {
  try {
    const response = await api.get('/sitios-muestreo');
    return response.data;
  } catch (error) {
    console.error('Error al obtener sitios de muestreo:', error);
    // Datos de ejemplo para desarrollo
    return [
      { id: 1, id_planta: 1, denominacion: 'Punto de descarga A', georreferencia_lat: -34.603722, georreferencia_long: -58.381592, utilizado: 1 },
      { id: 2, id_planta: 1, denominacion: 'Punto de descarga B', georreferencia_lat: -34.604872, georreferencia_long: -58.382593, utilizado: 1 },
      { id: 3, id_planta: 2, denominacion: 'Entrada principal', georreferencia_lat: -34.605122, georreferencia_long: -58.383594, utilizado: 1 },
      { id: 4, id_planta: 3, denominacion: 'Perímetro norte', georreferencia_lat: -34.601922, georreferencia_long: -58.380591, utilizado: 1 }
    ];
  }
};

// Obtener sitios de muestreo por planta
export const getSitiosMuestreoPorPlanta = async (plantaId: number): Promise<SitioMuestreo[]> => {
  try {
    const response = await api.get(`/sitios-muestreo`, {
      params: { id_planta: plantaId }
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener sitios de muestreo para la planta ${plantaId}:`, error);
    // Filtrar datos de ejemplo por id_planta
    const ejemplos = [
      { id: 1, id_planta: 1, denominacion: 'Punto de descarga A', georreferencia_lat: -34.603722, georreferencia_long: -58.381592, utilizado: 1 },
      { id: 2, id_planta: 1, denominacion: 'Punto de descarga B', georreferencia_lat: -34.604872, georreferencia_long: -58.382593, utilizado: 1 },
      { id: 3, id_planta: 2, denominacion: 'Entrada principal', georreferencia_lat: -34.605122, georreferencia_long: -58.383594, utilizado: 1 },
      { id: 4, id_planta: 3, denominacion: 'Perímetro norte', georreferencia_lat: -34.601922, georreferencia_long: -58.380591, utilizado: 1 }
    ];
    return ejemplos.filter(sitio => sitio.id_planta === plantaId);
  }
}; 